import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFleetinfoPage } from './klmr-fleetinfo';

@NgModule({
  declarations: [
    KlmrFleetinfoPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFleetinfoPage),
  ],
})
export class KlmrFleetinfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fleetinfo/klmr-fleetinfo.module.ts